// 成功信息
export const GET_SUCCESS_MESSAGE = 'GET_SUCCESS_MESSAGE'
export const SET_SUCCESS_MESSAGE = 'SET_SUCCESS_MESSAGE'
export const SET_SUCCESS_MESSAGE_STATE = 'SET_SUCCESS_MESSAGE_STATE'

// 错误信息
export const GET_FAIL_MESSAGE = 'GET_FAIL_MESSAGE'
export const SET_FAIL_MESSAGE = 'SET_FAIL_MESSAGE'
export const SET_FAIL_MESSAGE_STATE = 'SET_FAIL_MESSAGE_STATE'



// WEBPACK FOOTER //
// ./src/vuex/types/common/modal.js